import { onMounted, onUnmounted, shallowRef } from "vue";

export function useNow(intervalMs = 1000) {
	const nowMs = shallowRef<number>(Date.now());
	let timer: number | undefined;

	onMounted(() => {
		timer = window.setInterval(() => {
			nowMs.value = Date.now();
		}, intervalMs);
	});

	onUnmounted(() => {
		if (timer) {
			window.clearInterval(timer);
		}
	});

	return { nowMs };
}
